import { BoardColumn } from './BoardColumn';

export const BoardType = {
  RETROSPECTIVE: 'RETROSPECTIVE',
  RETROSPECTIVE_NOTES: 'RETROSPECTIVE_NOTES',
  RETROSPECTIVE_F: 'RETROSPECTIVE_F',
  RETROSPECTIVE_L: 'RETROSPECTIVE_L',
  BRAINSTORMING: 'BRAINSTORMING',
  DISCUSSION: 'DISCUSSION',
  RETROSPECTIVE_JOURNEY: 'RETROSPECTIVE_JOURNEY',
  RETROSPECTIVE_JOURNEY_NOTES: 'RETROSPECTIVE_JOURNEY_NOTES',
  TECH_RADAR: 'TECH_RADAR',
};

export const BoardColumnsByType = {
  [BoardType.RETROSPECTIVE]: [
    BoardColumn.DROP,
    BoardColumn.ADD,
    BoardColumn.KEEP,
    BoardColumn.IMPROVE,
    BoardColumn.OBSERVATION,
  ],
  [BoardType.RETROSPECTIVE_NOTES]: [
    BoardColumn.DROP,
    BoardColumn.ADD,
    BoardColumn.KEEP,
    BoardColumn.IMPROVE,
    BoardColumn.OBSERVATION,
    BoardColumn.NOTES,
  ],
  [BoardType.RETROSPECTIVE_F]: [
    BoardColumn.MAD,
    BoardColumn.SAD,
    BoardColumn.GLAD,
  ],
  [BoardType.RETROSPECTIVE_L]: [
    BoardColumn.LIKED,
    BoardColumn.LEARNED,
    BoardColumn.LACKED,
    BoardColumn.LONGER_FOR,
  ],
  [BoardType.BRAINSTORMING]: [BoardColumn.IDEA],
  [BoardType.DISCUSSION]: [
    BoardColumn.QUESTION,
    BoardColumn.COMMENT,
    BoardColumn.SUGGESTION,
  ],
  [BoardType.RETROSPECTIVE_JOURNEY]: [
    BoardColumn.WIND,
    BoardColumn.ANCHOR,
    BoardColumn.ROCKS,
    BoardColumn.SUN,
    BoardColumn.GOAL,
  ],
  [BoardType.RETROSPECTIVE_JOURNEY_NOTES]: [
    BoardColumn.WIND,
    BoardColumn.ANCHOR,
    BoardColumn.ROCKS,
    BoardColumn.SUN,
    BoardColumn.GOAL,
    BoardColumn.NOTES,
  ],
  [BoardType.TECH_RADAR]: [
    BoardColumn.HOLD,
    BoardColumn.ASSESS,
    BoardColumn.TRIAL,
    BoardColumn.ADOPT,
  ],
};
